<template lang="pug">
.fc-content(v-if="event.allDay")
  TimeOffEventPopover.fc-title.mr-5.ellipsis(
    v-if="extendedProps.isRequest"
    :request="request"
  )
    .fc-event-popover-trigger.ellipsis(slot="trigger")
      | {{ event.title }}
  span.fc-title(v-else)
    | {{ event.title }}
  span.event-duration All day
.vue-app-time-grid-event.fc-content(v-else)
  TimeOffEventPopover(
    v-if="extendedProps.isRequest"
    :request="request"
  )
    .fc-event-popover-trigger(slot="trigger")
      .fc-time
        span
          | {{ formattedRange }}
      .fc-title
        | {{ event.title }}
  TimeEntriesCalendarEventPopover(
    v-else
    :time-entry="timeEntry"
    @open-dialog="onOpenDialog"
  )
    .fc-event-popover-trigger(slot="trigger")
      .fc-time
        span
          | {{ formattedRange }}
      .fc-title
        span.mrt-icon-wrapper.mr-5(
          v-if="timeEntry.manual_time_request"
          v-tooltip="{ placement: 'top' }"
          title="This manual time request needs approval"
        )
          i.hi.hi-warning.cursor-pointer.text-warning-orange
        | {{ event.title }}
      .fc-org
        | {{ extendedProps.organization.name }}
      .fc-task(v-if="extendedProps.task")
        | {{ extendedProps.task.text }}
</template>
<script>
import TimeEntriesCalendarEventPopover from './TimeEntriesCalendarEventPopover.vue';
import { formatDatetimeRange } from '~/utils/time_utils';

export default {
  name: 'TimeEntriesCalendarEvent',
  components: {
    TimeEntriesCalendarEventPopover,
  },
  props: {
    timeZone: {
      type: String,
      default: '',
    },
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    start() {
      return this.createInZone(this.event.start);
    },
    stop() {
      return this.createInZone(this.event.end);
    },
    formattedRange() {
      return formatDatetimeRange(this.start, this.stop, { style: 'time' });
    },
    request() {
      return Object.assign({}, this.extendedProps.request, {
        start_time: this.start,
        stop_time: this.stop,
        organization: this.extendedProps.organization,
        avatarColor: this.extendedProps.avatarColor,
      });
    },
    timeEntry() {
      return Object.assign({}, this.extendedProps.timeEntry, {
        start_time: this.start,
        stop_time: this.stop,
        organization: this.extendedProps.organization,
        project: this.extendedProps.project,
        task: this.extendedProps.task,
        reasons: this.extendedProps.reasons,
      });
    },
    extendedProps() {
      return this.event.extendedProps;
    },
  },
  methods: {
    onOpenDialog(payload) {
      this.$emit('open-dialog', payload);
    },
    createInZone(date) {
      return moment(date).tz(this.timeZone);
    },
  },
};
</script>
